/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ActionType =
  | 'APPROVE'
  | 'APPROVE_WITHOUT_PREPARATION'
  | 'APPROVE_WITH_PREPARATION'
  | 'MODIFY'
  | 'REJECT';

export type GetOrderNextActionsQueryVariables = Exact<{
  orderReferenceId: string;
  userId: string;
  userCompanyId: string;
}>;


export type GetOrderNextActionsQuery = { getOrderNextActions: { actions: Array<Types.ActionType> } | null };


export const GetOrderNextActionsDocument = /*#__PURE__*/ gql`
    query getOrderNextActions($orderReferenceId: uuid!, $userId: uuid!, $userCompanyId: uuid!) {
  getOrderNextActions(
    orderReferenceId: $orderReferenceId
    userId: $userId
    userCompanyId: $userCompanyId
  ) {
    actions
  }
}
    `;

/**
 * __useGetOrderNextActionsQuery__
 *
 * To run a query within a React component, call `useGetOrderNextActionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderNextActionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderNextActionsQuery({
 *   variables: {
 *      orderReferenceId: // value for 'orderReferenceId'
 *      userId: // value for 'userId'
 *      userCompanyId: // value for 'userCompanyId'
 *   },
 * });
 */
export function useGetOrderNextActionsQuery(baseOptions: Apollo.QueryHookOptions<GetOrderNextActionsQuery, GetOrderNextActionsQueryVariables> & ({ variables: GetOrderNextActionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrderNextActionsQuery, GetOrderNextActionsQueryVariables>(GetOrderNextActionsDocument, options);
      }
export function useGetOrderNextActionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrderNextActionsQuery, GetOrderNextActionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrderNextActionsQuery, GetOrderNextActionsQueryVariables>(GetOrderNextActionsDocument, options);
        }
// @ts-ignore
export function useGetOrderNextActionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrderNextActionsQuery, GetOrderNextActionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrderNextActionsQuery, GetOrderNextActionsQueryVariables>;
export function useGetOrderNextActionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrderNextActionsQuery, GetOrderNextActionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrderNextActionsQuery | undefined, GetOrderNextActionsQueryVariables>;
export function useGetOrderNextActionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrderNextActionsQuery, GetOrderNextActionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrderNextActionsQuery, GetOrderNextActionsQueryVariables>(GetOrderNextActionsDocument, options);
        }
export type GetOrderNextActionsQueryHookResult = ReturnType<typeof useGetOrderNextActionsQuery>;
export type GetOrderNextActionsLazyQueryHookResult = ReturnType<typeof useGetOrderNextActionsLazyQuery>;
export type GetOrderNextActionsSuspenseQueryHookResult = ReturnType<typeof useGetOrderNextActionsSuspenseQuery>;
export type GetOrderNextActionsQueryResult = Apollo.QueryResult<GetOrderNextActionsQuery, GetOrderNextActionsQueryVariables>;